import { useMutation, useQuery } from "@tanstack/react-query";
import {
  createStpTransaction,
  deleteStpTransactionApi,
  getStpStats,
  updateStpTransactionApi,
} from "../../api/transaction/stp";
import { useInvalidateTransactionOrder } from "./transaction";

export const useCreateStpTransaction = (investmentAccountGuid: string) => {
  const { invalidate } = useInvalidateTransactionOrder(investmentAccountGuid);

  return useMutation({
    mutationKey: ["transaction/stp/create"],
    mutationFn: createStpTransaction,
    onSuccess: invalidate,
  });
};

export const useDeleteStpTransaction = (investmentAccountGuid: string) => {
  const { invalidate } = useInvalidateTransactionOrder(investmentAccountGuid);

  return useMutation({
    mutationKey: ["transaction/stp/delete"],
    mutationFn: deleteStpTransactionApi,
    onSuccess: invalidate,
  });
};

export const useUpdateStpTransaction = (investmentAccountGuid: string) => {
  const { invalidate } = useInvalidateTransactionOrder(investmentAccountGuid);

  return useMutation({
    mutationKey: ["transaction/stp/update"],
    mutationFn: updateStpTransactionApi,
    onSuccess: invalidate,
  });
};

export const useStpStats = (investmentAccountId: string, enabled = true) => {
  return useQuery({
    queryKey: ["stp-stats", investmentAccountId],
    queryFn: () => getStpStats(investmentAccountId),
    enabled,
  });
};
